import { Buffer } from 'buffer'

export const getPartnerPublicKey = (token?: string) => {
  if (token) {
    try {
      return JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString()).partnerPublicKey
    } catch (e) {
      return ''
    }
  }

  return ''
}
